/**
 * 物流公司
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2023, all rights reserved. Essa.cn
 *
 **/
import React from "react";
import { Menu, Dropdown, } from 'antd';
import Lang from "@components/Lang/Lang";
import {symbolMoneyUtil} from '@utils/utils';
import "./index.less"

export default class LogisticsCompanyList extends React.Component{
    static defaultProps = {
        logisticsCompanyList:[], //物流公司列表
        canClick: false,// 是否可点击, 点击后回调 当前点击的数据 (默认 纯展示 false,为true时有点击展示费用 官网等交互)
        logisticsCompanyId:"",
        showRecommend:true, //是否显示 推荐物流
        isRecommendOneTips:false, // 显示第一个推荐物流数据提示 , 配置为true时显示 将推荐物流列表中的第一个数据提示显示出来
        countryName:"",// 服务国家名称
        countryCode:"",  // 服务国家编码
        transitCityCode:"",//中转城市 code
        transitCityName:"",//中转城市
        currencySymbol:"",//对应货币
        showIntroduce: true, //展示介绍内容
    };
    constructor(props) {
        super(props);
        this.state = {
            currentItem: {},
            commonList:[],
            recommendList:[],
        }
    }
    /**
     * 进入 将数据分组
     * commonList 合作物流
     * recommendList 推荐物流
     * */
    init(){
        const { logisticsCompanyList=[],logisticsCompanyId,isRecommendOneTips } = this.props;
        let current = {},currRecommend={};
        const commonList =  logisticsCompanyList.filter(item=>item.type == 0)||[];
        const recommendList =  logisticsCompanyList.filter(item=>item.type == 1)||[];
        if(isRecommendOneTips){ // 显示第一个推荐物流数据提示
            current = recommendList.length>0?recommendList[0]:{};
        }else {
            current = logisticsCompanyId?logisticsCompanyList.find(item=>item.id == logisticsCompanyId):{};
            if(current&&current.type==1){
                currRecommend = current;
            }
        }
        this.setState({
            currRecommend:currRecommend||{},
            currentItem:current||{},
            commonList:commonList||[],//合作物流
            recommendList: recommendList||[], // 推荐物流
        })
    }
    /*
    * 渲染一个
    * */
    renderOne(logo={},inx,canClick,logisticsCompanyId){
        return (<div className={`logo${logo.logoFileUrl?" logoImg":""}${canClick?" cursor-p":""}${logisticsCompanyId==logo.id?" on":""}`}
                     key={inx} onClick={canClick?()=>this.onClickItem(logo):null}>
            {this.renderCon(logo,inx)}
        </div>)
    }
    /*
    * 渲染 推荐下拉
    * */
    renderDropdown(logo={},logisticsCompanyId){
        const {recommendList=[],} = this.state;
        let items = [];
        recommendList.filter((item,inx)=>{
            items.push({
                label:<div onClick={()=>this.handleMenuClick(item)}>
                    {item.name}
                </div>,
                key:"item_"+inx
            })
        })
        return (<Dropdown.Button className={`logo logoDropdown${logo.logoFileUrl?" logoImg":""}${logisticsCompanyId==logo.id?" on":""}`}
                                 onClick={((e)=>this.onClickItem(logo))}
                                 icon={<i className="ri-arrow-down-s-line color-black font-18"></i>}
                                 overlayClassName={"wrapDropdownSelect"}
                                 menu={{
                                     items,
                                 }}>
            {this.renderCon(logo,"logoDropdown",true)}
        </Dropdown.Button>)
    }
    /**
   * 渲染内容
   * @param showReTips 是否显示推荐物流提示
   * */
    renderCon(logo={},inx,showReTips=false){
        return (logo.logoFileUrl?<img src={logo.logoFileUrl} key={"logo_"+inx} />:<>
            <div className={"black89 font_14"} key={"name_"+inx}>{logo.name}</div>
            {showReTips&&<div className={"black45 font_12"} key={"remark_"+inx}>{Lang({id:"GenJuNiSuoZaiChengShiKeNengHeShi",default:"根据你所在城市，可能合适"})}</div>}
        </>)
    }
    handleMenuClick(item={}) {
        // const { item={} } = e;
        // const props = item.props || {}; props.obj
        this.setState({
            currRecommend : item
        })
        this.onClickItem(item)
    }
    /*
    * 点击 项 回调
    * */
    onClickItem(item={}){
        this.setState({
            currentItem:item
        })
       if(this.props.onClickLogistics) this.props.onClickLogistics(item)
    }
    renderRecom(currentItem={},transitCityName="",currencySymbol=""){
        return (<div className={"comShow"}>
            <div className={"fw_700 black89"}>{currentItem.name}</div>
            {/* 货物到你所在城市（莫斯科）,物流费用大概 xxxx 元 */}
            <p>
                {Lang({id:"HuoWuDaoNiSuoZaiChengShiWuLiuFeiYong",default:"货物到你所在城市（{0}）,物流费用大概 {1}",
                    params:[transitCityName, symbolMoneyUtil(currentItem.preRecommendPrice, currencySymbol)]})}
            </p>
        </div>)
    }
    componentDidMount() {
        this.init();
        if( this.props.onRef)this.props.onRef(this);
    };
    render() {
        const { className,canClick,logisticsCompanyList,logisticsCompanyId,isRecommendOneTips,showRecommend,currencySymbol,transitCityName,showIntroduce} = this.props;
        const { currentItem,commonList,recommendList,currRecommend } = this.state;

        return (<>
            <div className={`logoWrap${className?" "+className:""}`}>
                {commonList&&commonList.length>0?commonList.map((logo,inx)=>this.renderOne(logo,inx,canClick,logisticsCompanyId)):null}
                {showRecommend&&recommendList&&recommendList.length>0?(canClick?this.renderDropdown(currRecommend||recommendList[0],
                    logisticsCompanyId):recommendList.map((li,inx)=>this.renderOne(li,inx,canClick,logisticsCompanyId))):null}

                {/*{showRecommend&&recommendList&&recommendList.length>0?recommendList.map((logo,inx)=>this.renderOne(logo,inx,canClick,logisticsCompanyId)):null}*/}
            </div>
            {showIntroduce&&<>
                {/* 根据你的订单，以下物流公司可能合适 preRecommendPrice currencySymbol  */}
                {isRecommendOneTips&&recommendList&&recommendList.length>0?<p className={"mt_4 font_16 black89 mb_4"}>
                    {Lang({id:"GenJuNiDeDingDan",default:"根据你的订单，以下物流公司可能合适"})}
                </p>:null}
                {/* 推荐 物流 如果有推荐物流 需必定展示一个，如果点击即显示点击项内容*/}
                {currentItem&&currentItem.type==1?this.renderRecom(currentItem,transitCityName,currencySymbol):(showRecommend&&recommendList&&recommendList.length>0?this.renderRecom(currRecommend||recommendList[0],transitCityName,currencySymbol):null)}
                {/* dellin 第三方工具*/}
                {currentItem&&currentItem.type==0&&currentItem.name=="dellin"&&<div className={"coopShow"}>
                    <div className={"dellin"}>
                        <iframe
                            src="https://widgets.dellin.ru/calculator?derival_to_door=off&arrival_to_door=on&disabled_calculation=off&insurance=0&package=1"
                            width="332"
                            height="385"
                            scrolling="no"
                            frameBorder="0">
                        </iframe>
                    </div>
                    {/* 物流公司官网 */}
                    {currentItem.url&&<a className={"link linkFixed"} href={currentItem.url} target={"_blank"}>
                        {Lang({id:"WuLiuGongSiGuanWang",default:"物流公司官网"})}
                        <i className={"ri-share-box-line ml_2 font_14"} />
                    </a>}
                </div>}
                {/* 只能跳官网的 */}
                {canClick&&currentItem&&currentItem.type==0&&currentItem.name!="dellin"&&<div className={"coopShow flex-item-between"}>
                    <span className={"black89"}>
                        {Lang({id:"JiSuanWuLiuFeiYongQingZhuanDao",default:"计算物流费用请转到"})}
                    </span>
                    {/* 物流公司官网 */}
                 {currentItem.url&&<a className={"link"} href={currentItem.url} target={"_blank"}>
                       {Lang({id:"WuLiuGongSiGuanWang",default:"物流公司官网"})}
                        <i className={"ri-share-box-line ml_2 font_14"} />
                    </a>}
                </div>}
            </>}
        </>);
    }
}



